import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    title: 'title-4 py-2'
  },
  variant: 'quiet'
} satisfies RecursivePartial<CMSConfig['megaMenuL2Desktop']>
